import { HttpErrorResponse, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { ErrorHandler, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@zvoove-market/shared';
import { catchError, combineLatest, from, switchMap, throwError } from 'rxjs';

export const forbiddenInterceptor = () => {
  return (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const authService = inject(AuthService);
    const errorHandler = inject(ErrorHandler);
    const router = inject(Router);
    return next(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error instanceof HttpErrorResponse && error.status == 403 && hasCurrentUserRoles(error.error)) {
          const distinctClientRoles = Array.from(
            new Set([...authService.$context().globalRoles, ...(authService.$context().customer?.roles || [])])
          );
          const distinctServerRolesSet = new Set(error.error.currentUserRoles);
          if (distinctClientRoles.every((cRole) => distinctServerRolesSet.has(cRole))) {
            // 403 even though server has same view of roles as the client suggests that the client and server code missmatches
            errorHandler.handleError(error);
            return throwError(() => error);
          } else {
            // probably permissions changed on the server side
            return combineLatest([
              authService.refreshLoginContext(),
              authService.refreshAvailableMandantsByCustomers(),
              from(router.navigate(['/forbidden'])),
            ]).pipe(switchMap(() => throwError(() => error)));
          }
        }
        return throwError(() => error);
      })
    );
  };
};

function hasCurrentUserRoles(obj: unknown): obj is { currentUserRoles: string[] } {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    'currentUserRoles' in obj &&
    Array.isArray((obj as { currentUserRoles: unknown }).currentUserRoles)
  );
}
